import * as React from 'react'
import BaseBackgroundImage from 'gatsby-background-image';

type BackgroundImageProps = {
  className?: string,
  fluid: Pick<GatsbyTypes.ImageSharpFluid, 'aspectRatio' | 'src' | 'srcSetWebp' | 'srcWebp' | 'srcSet' | 'sizes'>
}

const BackgroundImage: React.FC<BackgroundImageProps> = ({
  className,
  fluid,
  children,
}) => {
  return (
    <BaseBackgroundImage
      Tag="div"
      className={className}
      fluid={fluid}
    >
      {children}
    </BaseBackgroundImage>
  )
}

export default BackgroundImage;
